"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Play, Headphones, Rss } from "lucide-react";
export default function PodcastOverview() {
  return <section id="podcast-overview" className="bg-background w-full py-24 md:py-32 px-4 sm:px-6 lg:px-8 flex flex-col items-center justify-center text-center overflow-hidden">
      <div className="max-w-5xl w-full flex flex-col items-center">
        {}
        <div className="mb-8 flex items-center gap-3">
          <div className="w-2 h-2 bg-primary rounded-none" />
          <span className="font-mono text-primary text-sm font-semibold tracking-widest uppercase">
            Audio Stream 
          </span>
        </div>

        {}
        <h1 className="font-serif text-5xl md:text-[4.5rem] font-extrabold tracking-tighter text-foreground leading-[1.1] mb-8 max-w-4xl">CAN cast with the CANcrew</h1>

        {}
        <p className="font-sans text-lg md:text-xl font-medium text-muted-foreground max-w-2xl mb-16 leading-relaxed">Discussing complex topic in simple terms, exploring local impact of broad policyt</p>

        {}
        <div className="w-full max-w-3xl border border-border rounded-lg bg-card p-4 sm:p-8 flex flex-col sm:flex-row items-center gap-8 shadow-sm mb-12 relative overflow-hidden group">
          {}
          <div className="absolute -right-20 -top-20 w-64 h-64 bg-primary/5 rounded-full blur-3xl pointer-events-none" />
          
          {}
          <div className="w-full sm:w-48 h-48 bg-muted rounded-md flex-shrink-0 overflow-hidden relative border border-border/50">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1644405/img/podcast_cover_architectural.png" alt="Podcast Episode Cover" className="w-full h-full object-cover grayscale opacity-90 mix-blend-multiply transition-transform duration-700 group-hover:scale-105" />
            <div className="absolute inset-0 flex items-center justify-center bg-background/10 backdrop-blur-[2px]">
              <Button size="icon" className="w-16 h-16 rounded-full bg-background/95 shadow-md border border-border hover:bg-background focus-visible:ring-2">
                <Play className="w-6 h-6 text-foreground ml-1" fill="currentColor" />
              </Button>
            </div>
          </div>

          {}
          <div className="flex flex-col items-start text-left flex-grow w-full z-10">
            <span className="font-mono text-xs text-primary font-medium mb-3 tracking-wider uppercase">
              Latest Episode 
            </span>
            <h3 className="font-serif text-2xl font-bold text-foreground mb-3 leading-tight">
              Structural Integrity & Aesthetic Form
            </h3>
            <p className="font-sans text-sm text-muted-foreground mb-6 line-clamp-2">
              An in-depth exploration of how structural integrity and aesthetic form will merge in the next century of urban development, featuring guest architect Dr. Aris Thorne.
            </p>
            
            {}
            <div className="w-full flex items-center gap-4 mt-auto">
              <span className="font-mono text-xs text-muted-foreground">00:00</span>
              <div className="flex-grow h-1.5 bg-secondary rounded-none overflow-hidden">
                <div className="w-1/3 h-full bg-primary rounded-none relative">
                  <div className="absolute right-0 top-1/2 -translate-y-1/2 w-2 h-2 bg-primary rounded-full shadow-sm" />
                </div>
              </div>
              <span className="font-mono text-xs text-muted-foreground">45:30</span>
            </div>
          </div>
        </div>

        {}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-8 w-full">
          <Button size="lg" className="rounded-lg font-sans font-semibold h-14 px-8 text-base w-full sm:w-auto shadow-sm" asChild>
            <Link to="#">
              <Headphones className="w-5 h-5 mr-2" />
              Subscribe on Spotify
            </Link>
          </Button>
          
          <div className="flex items-center gap-8">
            <Button variant="ghost" size="lg" className="rounded-lg font-sans font-medium h-14 px-6 text-base text-muted-foreground hover:text-foreground" asChild>
              <Link to="#">
                Apple Podcasts
              </Link>
            </Button>
            
            <Button variant="ghost" size="lg" className="rounded-lg font-sans font-medium h-14 px-6 text-base text-muted-foreground hover:text-foreground" asChild>
              <Link to="#">
                <Rss className="w-4 h-4 mr-2" />
                RSS
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}